module.exports = __webpack_public_path__ + "img/joint.9f981605.svg";